"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mammola": {
    "198f9adf": [{
      "hkey": "a4b83b6c",
      "slug": "mammola",
      "name": "Mammola",
      "primary": true,
      "skipSearch": false
    }],
    "aspalmo": [{
      "hkey": "a4b83b6c",
      "slug": "mammola",
      "name": "Mammola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "882269a6": [{
      "hkey": "a4b83b6c",
      "slug": "mammola",
      "name": "Mammola",
      "primary": true,
      "skipSearch": false
    }],
    "chiusa": [{
      "hkey": "a4b83b6c",
      "slug": "mammola",
      "name": "Mammola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ffcc9ddf": [{
      "hkey": "a4b83b6c",
      "slug": "mammola",
      "name": "Mammola",
      "primary": true,
      "skipSearch": false
    }],
    "santo-todaro": [{
      "hkey": "a4b83b6c",
      "slug": "mammola",
      "name": "Mammola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;